<!-- <div class="page-loader"></div> -->
<div class="content-wrapper">
  <section class="wrapper bg-light"  id="heroSection">
    <div class="container pt-8 pt-md-14">
      <div class="row gx-lg-0 gx-xl-8 gy-10 gy-md-13 gy-lg-0 mb-7 mb-md-10 mb-lg-16 align-items-center">
        <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-1 position-relative order-lg-2" data-cue="zoomIn">
          <div class="shape bg-dot primary rellax w-17 h-19" data-rellax-speed="1" style="top: -1.7rem; left: -1.5rem; "></div>
          <div class="shape rounded bg-soft-primary rellax d-md-block" data-rellax-speed="0" style="bottom: -1.8rem; right: -0.8rem; width: 85%; height: 90%;"></div>
          <figure class="rounded"><img src="./assets/img/photos/about7.jpg" srcset="./assets/img/Section-1new.jpg" alt="" /></figure>
        </div>
        <!--/column -->
        <div class="col-lg-5 mt-lg-n10 text-center text-lg-start" data-cues="slideInDown" data-group="page-title" data-delay="600" >
          <h1 class="display-1 mb-5" style="font-size: 2.3rem;">Transform Your Auto Parts Business with Our Next-Gen Commerce Platform</h1>
          <p class="lead fs-25 lh-sm mb-7 px-md-10 px-lg-0">Join the Revolution in the Auto Aftermarket Industry</p>
          <div class="d-flex justify-content-center justify-content-lg-start" data-cues="slideInDown" data-group="page-title-buttons" data-delay="900">
            <!-- <span><a href="#" class="btn btn-lg btn-primary rounded-pill me-2">Join Us</a></span> -->
            <a href="#" class="btn btn-lg btn-primary rounded-pill me-2" data-bs-toggle="modal" data-bs-target="#modal-join-us">Join Us</a>
            <!-- <span><a href="#" class="btn btn-lg btn-outline-primary rounded-pill">Free Trial</a></span> -->
          </div>
        </div>
        <!--/column -->
      </div>
      <!-- /.row -->
    </div>
  </section>
  <!-- /section -->

  <section class="wrapper bg-light">
    <div class="container py-5">
      <div class="row gy-10 gy-sm-13 gx-md-8 gx-xl-12 align-items-center">
        <div class="col-lg-6">
          <div class="row gx-md-5 gy-5">
            <div class="col-12">
              <figure class="rounded mx-5"><img src="./assets/img/photos/g8.jpg" srcset="./assets/img/Section-2.1.jpg" alt=""></figure>
            </div>
            <!--/column -->
            <div class="col-md-6">
              <figure class="rounded"><img src="./assets/img/photos/g9.jpg" srcset="./assets/img/Section-2.2.jpg" alt=""></figure>
            </div>
            <!--/column -->
            <div class="col-md-6">
              <figure class="rounded"><img src="./assets/img/photos/g10.jpg" srcset="./assets/img/Section-2.3.jpg" alt=""></figure>
            </div>
            <!--/column -->
          </div>
          <!--/.row -->
        </div>
        <!--/column -->

        <div class="col-lg-6">
          <section id="expand-your-reach">
            <h2 class="fs-16 text-uppercase text-muted mb-3">Expand Your Reach Across B2C & B2B Markets</h2>
          </section>

          <h3 class="display-3 mb-10">Join<span class="underline-3 style-2 yellow"> Autoverse Mobility:</span>  Your Gateway to the Automotive Aftermarket </h3>
          <div class="row gy-8">
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div>
                  <img src="./assets/img/icons/solid/lamp.svg" class="svg-inject icon-svg icon-svg-xs solid-mono text-fuchsia me-4" alt="" />
                </div>
                <div>
                  <h4 class="mb-1">Multi-Brand Garages</h4>
                  <p class="mb-0">Reliable parts supply with prompt delivery.</p>
                </div>
              </div>
            </div>
            <!--/column -->
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div>
                  <img src="./assets/img/icons/solid/bulb.svg" class="svg-inject icon-svg icon-svg-xs solid-mono text-violet me-4" alt="" />
                </div>
                <div>
                  <h4 class="mb-1">Fleet Management</h4>
                  <p class="mb-0">Bulk orders and dedicated support for fleets.</p>
                </div>
              </div>
            </div>
            <!--/column -->
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div>
                  <img src="./assets/img/icons/solid/puzzle.svg" class="svg-inject icon-svg icon-svg-xs solid-mono text-orange me-4" alt="" />
                </div>
                <div>
                  <h4 class="mb-1">Individual Customers</h4>
                  <p class="mb-0">Quality spare parts with hassle-free shopping.</p>
                </div>
              </div>
            </div>
            <!--/column -->
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div>
                  <img src="./assets/img/icons/solid/headphone.svg" class="svg-inject icon-svg icon-svg-xs solid-mono text-green me-4" alt="" />
                </div>
                <div>
                  <h4 class="mb-1">Comprehensive Solutions</h4>
                  <p class="mb-0">Custom offerings for businesses and individuals.</p>
                </div>
              </div>
            </div>
            <!--/column -->
          </div>
          <!--/.row -->
        </div>
        <!--/column -->
      </div>
      <!--/.row -->
    </div>
    <!-- /.container -->
  </section>
  <!-- /section -->

  <section id="why-choose-us" class="wrapper bg-gray position-relative min-vh-60 d-lg-flex align-items-center">
    <!-- <div class="col-lg-6 position-lg-absolute top-0 start-0 image-wrapper bg-image bg-cover h-100" data-image-src="./assets/img/photos/bg38.jpg"> -->
    <div class="col-lg-6 position-lg-absolute top-0 start-0 image-wrapper bg-image bg-cover h-100" data-image-src="./assets/img/Section_3(new).jpg">
      <div class="divider text-gray divider-v-end d-none d-lg-block">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 1200">
          <g />
          <g>
            <g>
              <polygon fill="currentColor" points="48 0 0 0 48 1200 54 1200 54 0 48 0" />
            </g>
          </g>
        </svg>
      </div>
    </div>
    <!--/column -->
    <div class="container">
      <div class="row gx-0">
        <div class="col-lg-6 ms-auto">
          <div class="pt-13 pb-15 pb-md-17 py-lg-16 ps-lg-15 pe-xxl-16">
            <section id="unlock-full-potential">
              <h2 class="fs-15 text-uppercase text-muted mb-3">Why Partner with Autoverse?</h2>
            </section>
            <h3 class="display-3 ls-sm mb-7">Unlock Your Full Potential with Autoverse</h3>
            <div class="d-flex flex-row mb-5">
              <div>
                <img src="./assets/img/icons/lineal/hourglass.svg" class="svg-inject icon-svg icon-svg-md text-sky me-5 mt-1" alt="" />
              </div>
              <div>
                <h4 class="fs-20 ls-sm">Scale Your Business</h4>
                <p class="mb-0">Expand your reach with our extensive network.Access top-quality parts.</p>
              </div>
            </div>
            <div class="d-flex flex-row mb-5">
              <div>
                <img src="./assets/img/icons/lineal/handshake.svg" class="svg-inject icon-svg icon-svg-md text-orange me-5 mt-1" alt="" />
              </div>
              <div>
                <h4 class="fs-20 ls-sm">Optimize Operations</h4>
                <p class="mb-0">Streamline your processes for maximum efficiency.Manage operations easily.</p>
              </div>
            </div>
            <div class="d-flex flex-row">
              <div>
                <img src="./assets/img/icons/lineal/invoice.svg" class="svg-inject icon-svg icon-svg-md text-aqua me-5 mt-1" alt="" />
              </div>
              <div>
                <h4 class="fs-20 ls-sm">Gain Actionable Insights</h4>
                <p class="mb-0">Get valuable data on part usage.Understand customer feedback.</p>
              </div>
            </div>
          </div>
        </div>
        <!--/column -->
      </div>
      <!--/.row -->
    </div>
    <!-- /.container -->
  </section>

  <section class="wrapper">
    <div class="container py-10">
      <div class="row d-flex align-items-start gy-10">
        <div class="col-lg-5 position-lg-sticky" style="top: 8rem;">
          <section id="key-offerings">
            <h3 class="display-2 mb-5">Key Offerings for Auto Component Manufacturers.</h3>
          </section>
          <p class="mb-7">Discover a suite of solutions designed to elevate your business. From comprehensive cataloging and efficient order fulfillment to robust customer support and insightful analytics.</p>
          <!-- <a href="#" class="btn btn-lg btn-primary btn-icon btn-icon-end">More Details <i class="uil uil-arrow-up-right"></i></a> -->
        </div>
        <!-- /column -->
        <div class="col-lg-6 ms-auto">
          <div class="card bg-soft-fuchsia mb-6">
            <div class="card-body d-flex flex-row">
              <div>
                <img src="./assets/img/icons/lineal/search-2.svg" class="svg-inject icon-svg icon-svg-md text-fuchsia me-5" alt="" />
              </div>
              <div>
                <h3 class="fs-21 mb-2">Comprehensive Cataloging</h3>
                <p class="mb-0">Effortlessly manage your parts catalog with thousands of SKUs.Over 2 lakh part numbers and 2.3 million variants.</p>
              </div>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
          <div class="card bg-soft-aqua mb-6">
            <div class="card-body d-flex flex-row">
              <div>
                <img src="./assets/img/icons/lineal/puzzle-2.svg" class="svg-inject icon-svg icon-svg-md text-aqua me-5" alt="" />
              </div>
              <div>
                <h3 class="fs-21 mb-2">Accurate Fitment Data</h3>
                <p class="mb-0">Standardized data for 6,500+ car models to ensure precise fitment.Reduce errors with reliable product information.</p>
              </div>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
          <div class="card bg-soft-yellow mb-6">
            <div class="card-body d-flex flex-row">
              <div>
                <img src="./assets/img/icons/lineal/smartphone.svg" class="svg-inject icon-svg icon-svg-md text-yellow me-5" alt="" />
              </div>
              <div>
                <h3 class="fs-21 mb-2">Order Fulfillment</h3>
                <p class="mb-0">Streamline order management with real-time tracking and updates.Deliver directly to B2B and B2C customers from your warehouse.</p>
              </div>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
          <div class="card bg-soft-leaf mb-6">
            <div class="card-body d-flex flex-row">
              <div>
                <img src="./assets/img/icons/lineal/design.svg" class="svg-inject icon-svg icon-svg-md text-leaf me-5" alt="" />
              </div>
              <div>
                <h3 class="fs-21 mb-2">Logistics Management</h3>
                <p class="mb-0">Utilize our integrated solution for efficient shipping and warehousing.Optimize inventory and reduce lead times throughout your network.</p>
              </div>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
          <div class="card bg-soft-orange mb-6">
            <div class="card-body d-flex flex-row">
              <div>
                <img src="./assets/img/icons/lineal/video-editing.svg" class="svg-inject icon-svg icon-svg-md text-orange me-5" alt="" />
              </div>
              <div>
                <h3 class="fs-21 mb-2">Customer Care Support</h3>
                <p class="mb-0">Enjoy dedicated customer service to ensure smooth transactions.Quickly resolve issues and enhance your customer experience.</p>
              </div>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
          <div class="card bg-soft-grape">
            <div class="card-body d-flex flex-row">
              <div>
                <img src="./assets/img/icons/lineal/browser.svg" class="svg-inject icon-svg icon-svg-md text-grape me-5" alt="" />
              </div>
              <div>
                <h3 class="fs-21 mb-2">Rich Analytics</h3>
                <p class="mb-0">Gain insights into part consumption and buying trends.Leverage data to improve product performance.</p>
              </div>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <!-- /column -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </section>
  <!-- /section -->

  <section class="wrapper bg-light">
    <div class="container py-10 text-center">
      <div class="row">
        <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <section id="garage-partner-benefits">
            <h2 class="fs-15 text-uppercase text-muted mb-3">Benefits for Garages and B2B Partners</h2>
          </section>
          <h3 class="display-4 mb-10 px-xl-10">Unlock efficiency, quality, and reliability in every order.</h3>
        </div>
        <!-- /column -->
      </div>
      <!-- /.row -->
      <div class="position-relative">
        <div class="shape rounded-circle bg-soft-blue rellax w-16 h-16" data-rellax-speed="1" style="bottom: -0.5rem; right: -2.2rem; z-index: 0;"></div>
        <div class="shape bg-dot yellow rellax w-16 h-17" data-rellax-speed="1" style="top: -0.5rem; left: -2.5rem; z-index: 0;"></div>
        <div class="row gx-md-5 gy-5 text-center">
          <div class="col-md-6 col-xl-3">
            <div class="card shadow-lg">
              <div class="card-body">
                <img src="./assets/img/icons/lineal/search-2.svg" class="svg-inject icon-svg icon-svg-md text-yellow mb-3" alt="" />
                <h4>Genuine Parts</h4>
                <p class="mb-2">Order genuine parts directly from manufacturers to avoid counterfeits and ensure quality repairs.</p>
                <!-- <a href="#" class="more hover link-yellow">Learn More</a> -->
              </div>
              <!--/.card-body -->
            </div>
            <!--/.card -->
          </div>
          <!--/column -->
          <div class="col-md-6 col-xl-3">
            <div class="card shadow-lg">
              <div class="card-body">
                <img src="./assets/img/icons/lineal/browser.svg" class="svg-inject icon-svg icon-svg-md text-red mb-3" alt="" />
                <h4>Procurement Efficiency</h4>
                <p class="mb-2">Experience timely deliveries to avoid costly downtime. Keep your operations running smoothly.</p>
                <!-- <a href="#" class="more hover link-red">Learn More</a> -->
              </div>
              <!--/.card-body -->
            </div>
            <!--/.card -->
          </div>
          <!--/column -->
          <div class="col-md-6 col-xl-3">
            <div class="card shadow-lg">
              <div class="card-body">
                <img src="./assets/img/icons/lineal/chat-2.svg" class="svg-inject icon-svg icon-svg-md text-green mb-3" alt="" />
                <h4>Fitment Accuracy</h4>
                <p class="mb-2">Access a comprehensive parts catalog for the right fit every time. Enhance service quality and minimize errors.</p>
                <!-- <a href="#" class="more hover link-green">Learn More</a> -->
              </div>
              <!--/.card-body -->
            </div>
            <!--/.card -->
          </div>
          <!--/column -->
          <div class="col-md-6 col-xl-3">
            <div class="card shadow-lg">
              <div class="card-body">
                <img src="./assets/img/icons/lineal/megaphone.svg" class="svg-inject icon-svg icon-svg-md text-blue mb-3" alt="" />
                <h4>Seamless Ordering</h4>
                <p class="mb-2">Use our Android and web apps for quick and easy order placement. Enjoy real-time updates for better planning.</p>
                <!-- <a href="#" class="more hover link-blue">Learn More</a> -->
              </div>
              <!--/.card-body -->
            </div>
            <!--/.card -->
          </div>
          <!--/column -->
        </div>
        <!--/.row -->
      </div>
      <!-- /.position-relative -->
    </div>
    <!-- /.container -->
  </section>
  <!-- /section -->
  
  <section class="wrapper bg-light">
    <div class="container py-10">
      <h2 class="display-4 mb-3">Partner with Autoverse Today!</h2>
      <p class="lead fs-lg mb-8">Here’s How <span class="underline">You Can </span> Join Us</p>
      <div class="row gx-lg-8 gx-xl-12 gy-6 process-wrapper line">
        <div class="col-md-6 col-lg-3"> <span class="icon btn btn-circle btn-lg btn-soft-primary pe-none mb-4"><span class="number">01</span></span>
          <h4 class="mb-1">Sign Up</h4>
          <p class="mb-0">Register on our platform and gain instant access to a vast network of garages, fleets, and B2C customers.          </p>
        </div>
        <!--/column -->
        <div class="col-md-6 col-lg-3"> <span class="icon btn btn-circle btn-lg btn-primary pe-none mb-4"><span class="number">02</span></span>
          <h4 class="mb-1">List Your Products</h4>
          <p class="mb-0">Upload your parts catalog with ease using our platform’s intuitive tools for cataloging and fitment data.       </p>
        </div>
        <!--/column -->
        <div class="col-md-6 col-lg-3"> <span class="icon btn btn-circle btn-lg btn-soft-primary pe-none mb-4"><span class="number">03</span></span>
          <h4 class="mb-1">Start Selling</h4>
          <p class="mb-0">Begin fulfilling orders from a broad customer base while leveraging our logistics and warehouse management system.          </p>
        </div>
        <!--/column -->
        <div class="col-md-6 col-lg-3"> <span class="icon btn btn-circle btn-lg btn-soft-primary pe-none mb-4"><span class="number">04</span></span>
          <h4 class="mb-1">Analyze & Optimize</h4>
          <p class="mb-0">Use our analytics tools to track sales, gather product feedback, and enhance your offerings.</p>
        </div>
        <!--/column -->
      </div>
      <!--/.row -->
    </div>
    <!-- /.container -->
  </section>
  <!-- /section -->

  <section class="wrapper bg-light">
    <div class="container py-10">
      <div class="row gx-lg-8 gx-xl-12 gy-10 align-items-center">
        <div class="col-lg-7 order-lg-2">
          <div class="row gx-md-5 gy-5">
            <div class="col-md-5 offset-md-1 align-self-end">
              <div class="card bg-pale-yellow">
                <div class="card-body">
                  <img src="./assets/img/icons/lineal/telephone-3.svg" class="svg-inject icon-svg icon-svg-md text-yellow mb-3" alt="" />
                  <h4>Comprehensive Support</h4>
                  <p class="mb-0">Enjoy end-to-end services from cataloging to customer support.</p>
                </div>
                <!--/.card-body -->
              </div>
              <!--/.card -->
            </div>
            <!--/column -->
            <div class="col-md-6 align-self-end">
              <div class="card bg-pale-red">
                <div class="card-body">
                  <img src="./assets/img/icons/lineal/shield.svg" class="svg-inject icon-svg icon-svg-md text-red mb-3" alt="" />
                  <h4>Tech Solutions</h4>
                  <p class="mb-0">Leverage AI, ML, and Google Cloud for efficient order fulfillment.</p>
                </div>
                <!--/.card-body -->
              </div>
              <!--/.card -->
            </div>
            <!--/column -->
            <div class="col-md-5">
              <div class="card bg-pale-leaf">
                <div class="card-body">
                  <img src="./assets/img/icons/lineal/cloud-computing-3.svg" class="svg-inject icon-svg icon-svg-md text-leaf mb-3" alt="" />
                  <h4>Market Reach</h4>
                  <p class="mb-0">Connect with garages, fleets, and customers.</p>
                </div>
                <!--/.card-body -->
              </div>
              <!--/.card -->
            </div>
            <!--/column -->
            <div class="col-md-6 align-self-start">
              <div class="card bg-pale-primary">
                <div class="card-body">
                  <img src="./assets/img/icons/lineal/analytics.svg" class="svg-inject icon-svg icon-svg-md text-primary mb-3" alt="" />
                  <h4>Data Insights</h4>
                  <p class="mb-0">Utilize analytics for part demand, product performance, and market trends to stay competitive.</p>
                </div>
                <!--/.card-body -->
              </div>
              <!--/.card -->
            </div>
            <!--/column -->
          </div>
          <!--/.row -->
        </div>
        <!--/column -->
        <div class="col-lg-5">
          <section id="unmatched-benefits">
            <h2 class="fs-15 text-uppercase text-muted mb-3" >Why Autoverse?</h2>
          </section>
          <h3 class="display-4 mb-5">Experience the unmatched benefits of Autoverse!</h3>
          <p>Unlock access to a vast network of garages, fleets, and customers with our tech-driven platform. Benefit from data insights and comprehensive support to streamline operations and stay ahead in the aftermarket.</p>
          <!-- <a href="#" class="btn btn-navy rounded-pill mt-3">More Details</a> -->
        </div>
        <!--/column -->
      </div>
      <!--/.row -->
    </div>
    <!-- /.container -->
  </section>
  <!-- /section -->

  <section class="wrapper gradient-8 bg-lines">
    <div class="container py-15 py-md-17 text-center">
      <div class="row">
        <div class="col-lg-10 col-xl-9 col-xxl-8 mx-auto text-center">
          <h2 class="fs-16 text-uppercase text-white mb-3">Get Started with Autoverse</h2>
          <h3 class="display-3 text-white mb-6">Take the next step in scaling your<span class="underline-2 underline-gradient-6"><em> auto parts business </em></span> by partnering with Autoverse. Click below to get started.</h3>
          <!-- <a href="#" class="btn btn-white">Join Us</a> -->
          <a href="#" class="btn btn-white rounded-pill mb-0 text-nowrap" data-bs-toggle="modal" data-bs-target="#modal-join-us">Join Us</a>
        </div>
        <!-- /column -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </section>
  <!-- /section -->
  
  <section class="wrapper bg-light">
    <div class="container py-10">
      <div class="row gx-md-8 gx-xl-12 gy-10 align-items-center">
        <div class="col-md-8 col-lg-6 offset-lg-0 col-xl-5 offset-xl-1 position-relative">
          <div class="shape bg-dot primary rellax w-17 h-21" data-rellax-speed="1" style="top: -2rem; left: -1.4rem;"></div>
          <figure class="rounded"><img src="./assets/img/photos/about4.jpg" srcset="./assets/img/Section-4.jpg" alt=""></figure>
        </div>
        <!--/column -->
        <div class="col-lg-6">
          <img src="./assets/img/icons/lineal/telemarketer.svg" class="svg-inject icon-svg icon-svg-md mb-4" alt="" />
          <h2 class="display-4 mb-8">Convinced yet? Let's make something great together.</h2>
          <div class="d-flex flex-row">
            <div>
              <div class="icon text-primary fs-28 me-6 mt-n1"> <i class="uil uil-location-pin-alt"></i> </div>
            </div>
            <div>
              <h5 class="mb-1">Address</h5>
              <address>
                A/4, 3rd Floor, 5TH Block<br class="d-none d-md-block" /> KHB Colony Koramangala, Bengaluru - 560095</address>
            </div>
          </div>
          <div class="d-flex flex-row">
            <div>
              <div class="icon text-primary fs-28 me-6 mt-n1"> <i class="uil uil-phone-volume"></i> </div>
            </div>
            <div>
              <h5 class="mb-1">Phone</h5>
              <p>8884998600</p>
            </div>
          </div>
          <div class="d-flex flex-row">
            <div>
              <div class="icon text-primary fs-28 me-6 mt-n1"> <i class="uil uil-envelope"></i> </div>
            </div>
            <div>
              <h5 class="mb-1">E-mail</h5>
              <p class="mb-0"><a href="mailto:hello@autoversemobility.in" class="link-body">hello@autoversemobility.in</a></p>
            </div>
          </div>
        </div>
        <!--/column -->
      </div>
      <!--/.row -->
    </div>
    <!-- /.container -->
  </section>
  <!-- /section -->

  <!-- Modal Join Us -->
  <div class="modal fade" id="modal-join-us" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content text-center">
        <div class="modal-body">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          <h2 class="mb-3 text-start">Join Us</h2>
          <p class="lead mb-6 text-start">Be part of our innovative automotive revolution!</p>
          <form class="text-start mb-3 needs-validation" name="contact-manufacturer" id="contact-manufacturer" method="POST" novalidate>
            <!-- <label class="form-check-label"> I am a </label>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="type" id="type1" value="Multibrand Garage Owner" checked>
              <label class="form-check-label" for="type1"> Multibrand Garage Owner </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="type" id="type2" value="Auto Parts Distributor">
              <label class="form-check-label" for="type2"> Auto Parts Distributor </label>
            </div>
            <div class="form-check mb-4">
              <input class="form-check-input" type="radio" name="type" id="type3" value="Auto Parts Manufacturer">
              <label class="form-check-label" for="type3"> Auto Parts Manufacturer </label>
            </div> -->

            <div class="form-floating mb-4">
              <input id="name" name="name" type="text" class="form-control" placeholder="Name" required onkeyup="checkSubmit();">
              <label for="name">Name<span style="color: red;">*</span></label>
              <div class="invalid-feedback">Please enter your name.</div>
            </div>
          
            <div class="form-floating mb-4">
              <input id="mobile" name="mobile" type="text" class="form-control" placeholder="Mobile Number" maxlength="10" required onkeyup="checkSubmit();" oninput="this.value = this.value.slice(0, 10);">
              <label for="mobile">Mobile Number<span style="color: red;">*</span></label>
              <div class="invalid-feedback">Please enter a valid mobile number (10 digits).</div>
            </div>
          
            <div class="form-floating mb-4">
              <input id="email" name="email" type="email" class="form-control" placeholder="Email ID" >
              <label for="email">Email ID</label>
              <!-- <div class="invalid-feedback">Please enter a valid email address.</div> -->
            </div>
            <input type="hidden" class="template-type" name="templateType" id="templateType" value="manufacturer">
            <button type="button" name="join-us" id="join-us" class="btn btn-primary rounded-pill btn-login w-100 mb-2" data-bs-dismiss="modal" onclick="formSubmit();">Join Us</button>
            <button type="submit" name="join-us-temp" id="join-us-temp" class="btn btn-primary rounded-pill btn-login w-100 mb-2">Join Us</button>  
          </form>          
        </div>
      </div>
    </div>
  </div>
  <!-- End Modal Join Us -->

  <!-- Modal Mail Sent -->
  <div class="modal fade" id="modal-email" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content text-center">
        <div class="modal-body">
          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          <h2 class="mb-3 text-center" id="email-success-title">Success</h2>
          <p id="success-email"><i class="uil uil-check-circle"></i></p>
          <p id="fail-email"><i class="uil uil-times-circle"></i></p>
          <p class="lead mb-6 text-center" id="email-success-subtitle">Email Sent Successfully</p>
          <button type="button" class="btn btn-primary rounded-pill btn-login w-100 mb-2" data-bs-dismiss="modal" onclick="redirectHome();">OK</button>
        </div>
      </div>
    </div>
  </div>
  <!-- End Modal Mail Sent -->
</div>

<div class="progress-wrap">
  <svg class="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
  </svg>
</div>